__turbopack_context__.v({
  "circled-chevron-down-icon": "CircledChevronDown-module-scss-module___VVGdq__circled-chevron-down-icon",
});
